import { Observable } from 'rxjs';
import { combineLatest } from 'rxjs/operator/combineLatest';

import { Injectable, ResolvedReflectiveProvider as RRP } from '@angular/core';

import {
  ContainerContent,
  Maybe,
  Overlay,
  DialogRef,
  DROP_IN_TYPE,
  Modal as Modal_,
  CSSBackdrop,
  CSSDialogContainer,
  PromiseCompleter
} from 'angular2-modal';

import { DropInPresetBuilder } from './presets/dropin-preset';

// TODO: use DI factory for this.
// TODO: consolidate dup code
const /** @type {?} */ isDoc: boolean = !(typeof document === 'undefined' || !document);
export class Modal extends Modal_ {
/**
 * @param {?} overlay
 */
constructor(overlay: Overlay) {
    super(overlay);
  }
/**
 * @return {?}
 */
alert(): DropInPresetBuilder {
    return new DropInPresetBuilder(this, DROP_IN_TYPE.alert, /** @type {?} */(( {isBlocking: false} as any)));
  }
/**
 * @return {?}
 */
prompt(): DropInPresetBuilder {
    return new DropInPresetBuilder(this, DROP_IN_TYPE.prompt, /** @type {?} */(( {
      isBlocking: true,
      keyboard: null
    }  as any)));
  }
/**
 * @return {?}
 */
confirm(): DropInPresetBuilder {
    return new DropInPresetBuilder(this, DROP_IN_TYPE.confirm, /** @type {?} */(( {
      isBlocking: true,
      keyboard: null
    }  as any)));
  }
/**
 * @param {?} dialogRef
 * @param {?} content
 * @param {?=} bindings
 * @return {?}
 */
protected create(dialogRef: DialogRef<any>,
                   content: ContainerContent,
                   bindings?: RRP[]): Maybe<DialogRef<any>> {

    const /** @type {?} */ backdropRef = this.createBackdrop(dialogRef, CSSBackdrop);
    const /** @type {?} */ containerRef = this.createContainer(dialogRef, CSSDialogContainer, content, bindings);

    let /** @type {?} */ overlay = dialogRef.overlayRef.instance;
    let /** @type {?} */ backdrop = backdropRef.instance;
    let /** @type {?} */ container = containerRef.instance;

    dialogRef.inElement ? overlay.insideElement() : overlay.fullscreen();

    // add body class if this is the only dialog in the stack
    if (isDoc && !document.body.classList.contains('vex-open')) {
      document.body.classList.add('vex-open');
    }

    overlay.addClass(`vex vex-theme-${dialogRef.context.className}`);
    backdrop.addClass('vex-overlay');
    container.addClass(dialogRef.context.contentClassName);
    container.setStyle('display', 'block');
    if (dialogRef.inElement) {
      overlay.setStyle('padding', '0');
      container.setStyle('margin-top', '20px');
    }

    if (containerRef.location.nativeElement) {
      containerRef.location.nativeElement.focus();
    }

    if (dialogRef.context.className === 'bottom-right-corner') {
      overlay.setStyle('overflow-y', 'hidden');
      container.setStyle('position', 'absolute');
    }

    overlay.beforeDestroy(() => {
      overlay.addClass('vex-closing');
      const /** @type {?} */ completer = new PromiseCompleter<void>();

      let /** @type {?} */ animationEnd$: Observable<any> = container.myAnimationEnd$();
      if (dialogRef.context.className !== 'bottom-right-corner') {
        animationEnd$ = combineLatest.call(animationEnd$, backdrop.myAnimationEnd$(), (s1, s2) => [s1,s2] );
      }

      animationEnd$.subscribe( sources => {
        isDoc && this.overlay.groupStackLength(dialogRef) === 1 && document.body.classList.remove('vex-open');
        completer.resolve();
      });

      return completer.promise;
    });


    overlay.setClickBoundary(containerRef.location.nativeElement);

    return dialogRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Overlay, },
];
}

function Modal_tsickle_Closure_declarations() {
/** @type {?} */
Modal.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Modal.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
